module.exports = __webpack_public_path__ + "static/media/BlueLogo.7bfcfa0b.svg";